<template>
  <div v-show="show">
    <FormKit
      :help-position="helpPosition"
      :help="field.instructions"
      :label-position="labelPosition"
      :label="field.name"
      :max="typeof field.maxValue === 'number' ? field.maxValue : undefined"
      :min="typeof field.minValue === 'number' ? field.minValue : undefined"
      :name="name"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="field.defaultValue"
      type="number"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldLabelPosition, fieldName, fieldNumberValidationArray, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: {
    instructions?: string
    name: string
    maxValue?: number
    minValue?: number
    placeholder?: string
    defaultValue?: number
    // Other field properties if any
  }
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const labelPosition = fieldLabelPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const show = fieldVisible(props.field)
const validation = [...fieldValidationArray(props.field), ...fieldNumberValidationArray(props.field)].filter((rule) => rule)
</script>
